<template>
  <div>
    <h1>Auth Check</h1>

    <h2>Admin Auth</h2>
    <section>
      <dl>
        <dt>Admin Login</dt>
        <dd>
          <input type="email" name="email" v-model="adminForm.email" style="border-width: medium;" placeholder="E-Mail" />
        </dd>
        <dd>
          <input type="password" name="password" v-model="adminForm.password" style="border-width: medium;" placeholder="Password" />
        </dd>
        <dd>
          <button @click="login('auth/admin/login', adminForm)">Login</button>
        </dd>
      </dl>
      <dl>
        <dt>G-Plus User Login</dt>
        <dd>
          <input type="email" name="email" v-model="userForm.email" style="border-width: medium;" placeholder="E-Mail" />
        </dd>
        <dd>
          <input type="password" name="password" v-model="userForm.password" style="border-width: medium;" placeholder="Password" />
        </dd>
        <dd>
          <button @click="login('auth/user/login', userForm)">Login</button>
        </dd>
      </dl>

      <dl>
        <dt>Guest User Login</dt>
        <dd>
          <input type="text" name="slug" v-model="eventSlug" style="border-width: medium;" placeholder="Event Slug" />
        </dd>
        <dd>
          <input type="text" name="auth_code_one" v-model="guestForm.auth_code_one" style="border-width: medium;" placeholder="Auth Code ONE" />
        </dd>
        <dd>
          <input type="text" name="auth_code_two" v-model="guestForm.auth_code_two" style="border-width: medium;" placeholder="Auth Code TWO" />
        </dd>
        <dd>
          <button @click="login(`auth/${eventSlug}/guest/login`, guestForm)">Login</button>
        </dd>
      </dl>

      <dl>
        <dt>Get Current Auth User</dt>
        <dd>
          <button @click="self">Get self</button>
        </dd>
        <dt>Result</dt>
        <dd v-if="user.id">ID: {{ user.id }}</dd>
        <dd v-if="user.name">NAME: {{ user.name }}</dd>
        <dd v-if="user.email">E-MAIL: {{ user.email }}</dd>
      </dl>
      <dl>
        <dt>Logout</dt>
        <dd>
          <button @click="logout">Logout</button>
        </dd>
      </dl>
    </section>
    <br />
  </div>
</template>

<script>
export default {
  name: "Auth",
  data: function() {
    return {
      adminForm: {},
      userForm: {},
      guestForm: {},
      eventSlug: "",
      messages: {
        admin: {},
        user: {}
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/user"]
    }
  },
  methods: {
    /**
     * ログイン
     * @param endpoint
     * @param inputs
     * @returns {Promise<void>}
     */
    async login(endpoint, inputs) {
      // storeを使うとリダイレクトされてしまうので、個別で処理を用意
      await this.$axios
        .post(endpoint, inputs)
        .then(response => {
          const data = response.data
          this.$store.commit("auth/setUserId", `${data.account_type}_${data.account_id}`)
          this.$store.commit("auth/setToken", data.token)

          this.$axios.setToken(data.token)
          this.$socket.init()
          alert(data.message)
        })
        .catch(error => {
          console.error(error)
          this.messages.admin.login = error.response.data
        })
    },
    async self() {
      await this.$store.dispatch("auth/self")
    },
    async logout() {
      await this.$store.dispatch("auth/logout")
    }
  }
}
</script>

<style scoped>
dl {
  border: solid 1px;
  padding: 16px;
}

dt {
  font-weight: bold;
}

dt:after {
  content: ":";
}

dd {
}

button {
  color: #fff;
  background: #8fbcbb;
  border: solid 1px #8fbcbb;
  border-radius: 4px;
  padding: 4px;
}
</style>
